export default __webpack_public_path__ + "static/media/ic_reuse_24px.122ac7c5.svg";